import { Interval, DateTime } from 'luxon'

const getFormatedDate = ({ isoString, withYear, withTime, justTime }) => {
  let formatedDate = ''
  const diff = Interval.fromDateTimes(DateTime.fromISO(isoString), DateTime.now())

  if (diff) {
    formatedDate = DateTime.fromISO(isoString)
      .toFormat(`LLL dd${withYear ? ', yyyy' : ''} ${withTime ? 'T' : ''}`)
  } else {
    formatedDate = DateTime.fromISO(isoString).toFormat('T')
  }
  if (justTime) {
    formatedDate = DateTime.fromISO(isoString).toFormat('hh:mm')
  }

  return formatedDate
}

export default getFormatedDate
